export default "__VITE_ASSET__73e75881__"